import React, { useEffect, useState } from "react";
import { submitPollAnswer } from "../../../../../redux/slices/earnPointSlice";
import { connect, useSelector } from "react-redux";
import { pollsStyle as styles } from "./currentPolls.tailwind";
import Spinner from "../../../../shared/Loaders/Spinner";
import { Avatar } from "@mui/material";
import { getFirstCharUpperCase, getRandomColor, POLL_VOTEDFOR } from "../../../../../lib/constants/globalConstant";

const Polls = ({
  poll,
  question,
  options,
  pollIndex,
  pollId,
  submitAnswer,
  userId,
  onSubmit,
  isLivePoll,
  isPollAttempted,
  gameId
}) => {
  const { user } = useSelector((state) => state?.user);
  const { currentSeason } = useSelector((state) => state?.seasons);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isCurrentlyPollLoading, setIsCurrentlyPollLoading] = useState(false);

  const firstChar = getFirstCharUpperCase(user?.userDetails?.userNickName);
  const avatarColor = getRandomColor(firstChar);
  const totalVotesForCurrentPoll = poll?.totalVotesDetail?.find(vote => gameId ? ((vote?.votedFor === POLL_VOTEDFOR.GAME) && (vote?.gameId === gameId)) : (vote?.votedFor === POLL_VOTEDFOR.SEASON))?.totalVotes || 0;

  const handleVote = async (label, index) => {
    if (!isPollAttempted && !isCurrentlyPollLoading) {
      setIsCurrentlyPollLoading(true);

      const selectedOptionId = options?.[index]?.id;
      setSelectedOption(selectedOptionId)

      const data = {
        pollId: pollId,
        answers: [
          {
            _id: selectedOptionId,
          },
        ],
        seasonId: currentSeason?._id,
        gameId,
        votedFor: gameId ? POLL_VOTEDFOR.GAME : POLL_VOTEDFOR.SEASON,
      };

      const respone = await submitAnswer({ data, userId, showSnackbarOnBottom: isLivePoll, isLivePoll });
      if(submitPollAnswer.fulfilled.match(respone)){
        setIsCurrentlyPollLoading(false);
        onSubmit?.(pollIndex);
      }else{
        setIsCurrentlyPollLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isPollAttempted) {
      // Determine if we're checking for game context or season context
      const votedFor = gameId ? POLL_VOTEDFOR.GAME : POLL_VOTEDFOR.SEASON; // 2 for game, 1 for season
      
      // Find the option the user voted for in this specific context
      const option = options?.find((option) => 
        option?.voteDetails?.some(vote => 
          vote?.votedFor === votedFor &&
          vote?.userIds?.some(_userId => _userId === userId) && 
          (votedFor === POLL_VOTEDFOR.SEASON || (votedFor === POLL_VOTEDFOR.GAME && vote.gameId === gameId))
        )
      );

      setSelectedOption(option?.id);
    }
  }, [isPollAttempted, userId, options, gameId]);

  return (
    <div className={`${styles.outerContainer} ${isLivePoll ? styles.outerContainerLive : ""}`}>
      <div className={`${styles.polls} ${isLivePoll ? styles.pollsLive : ""}`}>
        {isCurrentlyPollLoading && (
          <div className={styles.spinnerContainer}>
            <Spinner />
          </div>
        )}
        <h2 className={styles.question}>{question}</h2>

        {isPollAttempted && (
            <div className={styles.votesvalue}>
            Total Votes: {totalVotesForCurrentPoll}
          </div>
        )}
        
        <div className={styles.options}>
          {options?.map((option, index) => {
            const optionTotalVotes = option?.voteDetails?.find(vote => gameId ? ((vote?.votedFor === POLL_VOTEDFOR.GAME) && (vote?.gameId === gameId)) : (vote?.votedFor === POLL_VOTEDFOR.SEASON))?.userIds?.length || 0;
            
            return (
              <div
                key={index}
                className={`${styles.optionContainer} ${selectedOption === option?.id ? `${styles.optionSelected}` : ""} ${isPollAttempted ? "" : "cursor-pointer"} relative`}
                onClick={() => handleVote(option?.label, index)}
              >
                <div className={styles.optionText}>{option?.label}</div>

                {isPollAttempted && (
                  <div className={styles.percent_img}>
                    {selectedOption === option?.id && (
                      <>
                      {user?.userDetails?.profileImageUrl ? (
                        <img src={user?.userDetails?.profileImageUrl} alt="" className={styles.polls_img}/>
                      ) : (
                        <Avatar sx={{ width: 17, height: 17, bgcolor: avatarColor, fontSize: 9, lineHeight: '8px' }}>
                          {firstChar}
                        </Avatar>
                      )}
                      </>
                    )}
                    {Math.min((optionTotalVotes/ totalVotesForCurrentPoll)*100 || 0, 100)?.toFixed(2)}%
                  </div>
                )}

                {isPollAttempted && (
                  <span style={{
                    height: '100%',
                    width: Math.min((optionTotalVotes/ totalVotesForCurrentPoll)*100 || 0, 100) + "%",
                    position: 'absolute',
                    left: -1,
                    top: 0,
                    zIndex: 0,
                    background: '#174986',
                    borderRadius: '8px',
                  }} />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  submitAnswer: (data) => dispatch(submitPollAnswer(data)),
});

export default connect(null, mapDispatchToProps)(Polls);